import { getHistoryState, JoinCard } from "@indietabletop/appkit";
import { ViewContainer } from "../max-width-container";
import { MobileNavLayout } from "../mobile-nav-layout";

export function JoinPage() {
  return (
    <MobileNavLayout title="Join">
      <ViewContainer padding="small">
        <JoinCard defaultValues={{ email: getHistoryState()?.emailValue }} />
      </ViewContainer>
    </MobileNavLayout>
  );
}
